export default {
  quantities              : ['4', '10', '50', '100'],
  part_number             : '',
  revision                : '',
  number_of_layers        : '2',
  board_length            : '',
  board_width             : '',
  smallest_hole_size_range: '12+',
  gold_thickness          : 'Au<10',
  blind_buried_hole       : 'none',

  has_array      : '0',
  is_panelized   : '',
  array_x        : '',
  array_y        : '',
  array_up       : '',
  array_x_qty    : '',
  array_y_qty    : '',
  array_spacing_x: '',
  array_spacing_y: '',
  rails_left     : '',
  rails_right    : '',
  rails_top      : '',
  rails_bottom   : '',
  tab_rout       : '0',
  scoring        : '0',

  material_type                : 'FR4',
  material_thickness           : '0.062',
  material_type_finish_plating : 'FR4/Leaded Solder',
  finish_plating               : 'Leaded Solder',
  copper_inners                : '1 oz',
  copper_outers                : '1 oz',

  min_trace_space : 0.012,
  solder_sides    : 'Both Sides',
  solder_color    : 'green',
  silkscreen_sides: 'Both Sides',
  silkscreen_color: 'White',

  has_advanced_specs         : '0',
  plated_edges               : '0',
  number_of_counterbore_holes: '',
  number_of_countersink_holes: '',
  gold_fingers_booth_side    : '',

  ul            : '1',
  lot_code      : '1',
  panel_approval: '0',

  quote_weight: '0',
  weight_unit : 'kg',
  special_instructions: '',
};
